<button class="full-screen-button"
        nbButton
        size="large"
        ghost
        (click)="toggleFullScreen()">
  <nb-icon pack="eva" [icon]="icon"></nb-icon>
</button>
